<script>
    import ItemTypeIconCell from "../Browsing/ItemTypeIconCell.svelte";
    import ItemDateCell from "../Browsing/ItemDateCell.svelte";
    import ItemNameOnlyCell from "../Browsing/ItemNameOnlyCell.svelte";
    import ItemInfoCell from "../Browsing/ItemInfoCell.svelte";
    import TableActionCell from "./TableActionCell.svelte";
    import schemaData from "../../Stores/wpn2SchemaStore.js";
    import ItemStatusIconCell from "../Browsing/ItemStatusIconCell.svelte";
    import { createEventDispatcher } from "svelte";
    import {sortByStatus } from "../../scripts/wpn2Browse.js";

    const dispatch = createEventDispatcher();

    export let items;
    export let cellButtonTypes;
    let columnAttribs = makeColumnAttributes();
    let sortBy = {key: "status", ascending: false};
    let showItemsCount;

    $: showItemsCount = Math.min(items.length, 100);
    $: entity = (showItemsCount > 0) ? items[0].entity : null;

    $: sort = (column) => {
        adjustColumnSortRule(column);
		// Modifier to sorting function for ascending or descending
		let sortModifier = (sortBy.ascending) ? 1 : -1;
		let sort = (a, b) => 
			(a[column] < b[column]) 
			? -1 * sortModifier 
			: (a[column] > b[column]) 
			? 1 * sortModifier 
			: 0;
        items = items.sort(sort);
        dispatch("sort", { sortedData: items });
	}

    $: sortRGB = (column) => {
        adjustColumnSortRule(column);
		// Modifier to sorting function for ascending or descending
		let sortModifier = (sortBy.ascending) ? 1 : -1;
        items = sortByStatus(items, sortModifier);
        dispatch("sort", { sortedData: items });
    }

    function adjustColumnSortRule(column) {
		if (sortBy.key == column) {
			sortBy.ascending = !sortBy.ascending;
		} else {
			sortBy.key = column;
			sortBy.ascending = true;
		}
    }

    function makeColumnAttributes() {
        const key1Info = ['icon_name', 'name', 'status'].map((x) => $schemaData['keysList'].find(y => y.key === x));
        const briefInfo = { key: "brief", title: "Summary" };
        const key2Info = ['last_updated'].map(x => $schemaData['keysList'].find(y => y.key === x));
        const buttonInfo = cellButtonTypes.map(x => { return { key: x, title: x }; });
        return key1Info.concat(briefInfo).concat(key2Info).concat(buttonInfo);
    }
</script>

<table class="items-table">
    <thead>
        <tr>
            {#each columnAttribs as x}
                {#if ['status'].includes(x.key)}
                    {#if ['Sensor', 'SoundLocation'].includes(entity)}
                        <th on:click={sortRGB(x.key)}>{x.title}</th>
                    {:else}
                        <th on:click={sort(x.key)}>{x.title}</th>
                    {/if}
                {:else if ['name', 'last_updated'].includes(x.key)}
                    <th on:click={sort(x.key)}>{x.title}</th>
                {:else}
                    <th class="non-sortable">{x.title}</th>
                {/if}
            {/each}
        </tr>
    </thead>
    <tbody>
        {#each items as item, index}
            {#if index < showItemsCount}
                <tr>
                    {#each columnAttribs as x}
                        {#if x.key == "icon_name"}
                            <td><ItemTypeIconCell {item} /></td>
                        {:else if x.key == "name"}
                            <td><ItemNameOnlyCell {item} /></td>
                        {:else if x.key == "status"}
                            <td><ItemStatusIconCell {item} /></td>
                        {:else if x.key == "brief"}
                            <td><ItemInfoCell {item} /></td>
                        {:else if x.key == "last_updated"}
                            <td><ItemDateCell {item} /></td>
                        {:else if x.key == "Add"}
                            <TableActionCell {item} action={x.key} on:item-add />
                        {:else if x.key == "Edit"}
                            <TableActionCell {item} action={x.key} on:item-edit />
                        {:else if x.key == "Info"}
                            <TableActionCell {item} action={x.key} on:item-select />
                        {:else if x.key == "Map"}
                            <TableActionCell {item} action={x.key} on:find-on-map />
                        {:else if x.key == "Remove"}
                            <TableActionCell {item} action={x.key} on:item-remove />
                        {/if}
                    {/each}
                </tr>
            {/if}
        {/each}
    </tbody>
</table>
{#if items.length > showItemsCount}
    <div>
        <p id="more-statement">
            More results available - try narrowing the search
        </p>
        <a class="active-link" id="more-link" href={"#"} on:click={() => { showItemsCount += 100 }}
            >Show more</a>
</div>
{/if}

<style>
    .items-table {
        text-align: center;
        -webkit-border-vertical-spacing: 0;
        border-collapse: collapse;
        table-layout: auto;
        padding: 8px;
        width: 100%;
    }
    #more-statement {
        padding: 4px 16px;
    }
    #more-link {
        padding: 16px;
    }
</style>
